var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:({backgroundImage:`url(${_vm.chatBg})`,backgroundWith:'100%',})},[_c('div',{staticClass:"inner"},[_c('iframe',{staticStyle:{"width":"680px","height":"610px"},attrs:{"src":_vm.urlLink,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }